import { createSelector } from "reselect";
import * as S from "sanctuary";

const getState = (state) => state.payment;

export const getPayment = (state) => getState(state).payment;

export const getFetchPaymentRequestIsPending = (state) =>
  getState(state).fetchRequestPending;

export const getFetchPaymentRequestError = (state) =>
  getState(state).fetchRequestError;

export const getVoidPaymentRequestIsPending = (state) =>
  getState(state).voidRequestPending;

export const getVoidPaymentRequestError = (state) =>
  getState(state).voidRequestError;

export const getRefundPaymentRequestIsPending = (state) =>
  getState(state).refundRequestPending;

export const getRefundPaymentRequestError = (state) =>
  getState(state).refundRequestError;

export const getPaymentModificationPreAuthRequestError = (state) =>
  getState(state).paymentModificationPreAuthError;

export const getPaymentModificationPreAuthRequestPending = (state) =>
  getState(state).paymentModificationPreAuthRequestPending;

export const getPaymentId = createSelector(getPayment, (payment) =>
  S.isJust(payment) ? payment.value.id : S.Nothing
);

export const getPartialRefundContainerOpen = (state) =>
  getState(state).partialRefundContainerOpen;

export const getPartialRefundItems = (state) => getState(state).partialRefundItems;

export const getReceiptDownloadPending = (state) =>
  getState(state).receiptDownloadPending;

export const getVoidRefundModalOpen = (state) => getState(state).voidRefundModalOpen;

export const getRefundWindows = (state) => getState(state).refundWindows;
